@if (isVisible) {
<section [class]="['status', props.statusType ?? 'neutral']">
    @if ( !!props.icon || !!props.label ) {
    <div [class]="['display-flex','flex-full']">
        @if ( !!props.icon ) {
        <mat-icon class='mutara-icon'>{{props.icon}}</mat-icon>
        }
        @if ( !!props.label ) {
        <mat-label>
            <h2 class="mat-headline-3">{{props.label | substitution:this}}</h2>
        </mat-label>
        }
    </div>
    }
    @if ( !!props.description ) {
    <markdown [disableSanitizer]="true">{{props.description | substitution:this}}</markdown>
    }
    @if (!!props.description && !!props.secondaryText) {
    <br />
    }
    @if ( !!props.secondaryText ) {
    <markdown class="centered" [disableSanitizer]="true">{{props.secondaryText | substitution:this}}</markdown>
    }
</section>
}